import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "buildNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.BUILD.fullString,
    hasInputLabel: true,
  },
];
